export const WORK_FILTERS = [
  "All",
  "Small Business",
  "Restaurant",
  "Automotive",
  "Contractor",
  "E-commerce",
  "Personal Brand",
] as const;

export type WorkCategory = Exclude<(typeof WORK_FILTERS)[number], "All">;

export type Project = {
  slug: string;
  category: WorkCategory;
  title: string;
  summary: string;
  problem: string;
  solution: string;
  pages: string[];
};

/** Placeholder projects — replace with real client work when supplied. */
export const PROJECTS: Project[] = [
  {
    slug: "placeholder-small-business",
    category: "Small Business",
    title: "Small Business project",
    summary: "Case study slot reserved for a real small-business client.",
    problem: "Placeholder — describe the client's situation before the new site (outdated design, no mobile version, hard to contact).",
    solution: "Placeholder — describe what NEXORA designed and built, and why.",
    pages: ["Home", "Services", "About", "Contact"],
  },
  {
    slug: "placeholder-restaurant",
    category: "Restaurant",
    title: "Restaurant project",
    summary: "Case study slot reserved for a real restaurant client.",
    problem: "Placeholder — e.g. menu only available as a PDF, hours out of date across the web.",
    solution: "Placeholder — e.g. mobile menu, live hours, reservations and delivery links.",
    pages: ["Home", "Menu", "Reservations", "Location & Hours"],
  },
  {
    slug: "placeholder-automotive",
    category: "Automotive",
    title: "Automotive project",
    summary: "Case study slot reserved for a real automotive client.",
    problem: "Placeholder — describe how customers booked service before.",
    solution: "Placeholder — describe the booking flow and service pages built.",
    pages: ["Home", "Services", "Book Service", "Reviews"],
  },
  {
    slug: "placeholder-contractor",
    category: "Contractor",
    title: "Contractor project",
    summary: "Case study slot reserved for a real contractor client.",
    problem: "Placeholder — describe how leads came in before the new site.",
    solution: "Placeholder — describe the project gallery, service areas and estimate form.",
    pages: ["Home", "Gallery", "Service Areas", "Free Estimate"],
  },
  {
    slug: "placeholder-ecommerce",
    category: "E-commerce",
    title: "E-commerce project",
    summary: "Case study slot reserved for a real online store.",
    problem: "Placeholder — describe how the client sold before going online.",
    solution: "Placeholder — describe the product catalog, cart and checkout.",
    pages: ["Shop", "Product", "Cart", "Checkout"],
  },
  {
    slug: "placeholder-personal-brand",
    category: "Personal Brand",
    title: "Personal Brand project",
    summary: "Case study slot reserved for a real personal-brand client.",
    problem: "Placeholder — describe the client's goals and audience.",
    solution: "Placeholder — describe the story, offers and booking pages built.",
    pages: ["Home", "About", "Work With Me", "Contact"],
  },
];
